/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

interface IErrorMessage {
    text?: string;
}

export const ErrorMessage: React.FC<IErrorMessage> = ({ text }) => {
    return (
        <>
            <div className='row no-products'>
                <svg xmlns='http://www.w3.org/2000/svg' width='232' height='232' viewBox='0 0 232 232' fill='none'>
                    <g clipPath='url(#clip0_1501_9301)'>
                        <circle cx='115.273' cy='127.302' r='95.8982' fill='#F8F4FF' />
                        <circle cx='25.3857' cy='62.55' r='6.01071' fill='#F8F4FF' />
                        <circle cx='148.604' cy='20.2018' r='11.2018' fill='#F8F4FF' />

                        <circle cx='34.4015' cy='203.802' r='10.6554' fill='#F8F4FF' />

                        <circle cx='197.234' cy='190.687' r='5.19107' fill='#F8F4FF' />

                        <path
                            d='M120.751 36.0685C120.434 36.0011 120.434 35.549 120.751 35.4816L125.541 34.463C125.656 34.4385 125.747 34.3485 125.772 34.2332L126.803 29.4771C126.871 29.1619 127.321 29.1619 127.389 29.4771L128.421 34.2332C128.446 34.3485 128.536 34.4385 128.651 34.463L133.441 35.4816C133.758 35.549 133.758 36.0011 133.441 36.0685L128.651 37.0871C128.536 37.1116 128.446 37.2016 128.421 37.3169L127.389 42.073C127.321 42.3882 126.871 42.3882 126.803 42.073L125.772 37.3169C125.747 37.2016 125.656 37.1116 125.541 37.0871L120.751 36.0685Z'
                            fill='#D8BBFF'
                        />

                        <path
                            d='M11.2986 133.925C11.4209 133.348 12.2455 133.348 12.3678 133.925L14.1944 142.555C14.2389 142.765 14.4026 142.93 14.6126 142.976L23.153 144.836C23.7265 144.961 23.7265 145.779 23.153 145.904L14.6126 147.765C14.4026 147.81 14.2389 147.975 14.1944 148.185L12.3678 156.815C12.2455 157.393 11.4209 157.393 11.2986 156.815L9.47198 148.185C9.42746 147.975 9.26376 147.81 9.05371 147.765L0.513302 145.904C-0.0601874 145.779 -0.060185 144.961 0.513305 144.836L9.05371 142.976C9.26376 142.93 9.42746 142.765 9.47198 142.555L11.2986 133.925Z'
                            fill='#D8BBFF'
                        />

                        <path
                            d='M200.974 65.0756C201.096 64.4979 201.921 64.4979 202.043 65.0756L203.109 70.1099C203.153 70.3202 203.317 70.4849 203.527 70.5306L208.524 71.6191C209.097 71.7441 209.097 72.562 208.524 72.6869L203.527 73.7754C203.317 73.8212 203.153 73.9859 203.109 74.1962L202.043 79.2304C201.921 79.8081 201.096 79.8081 200.974 79.2304L199.909 74.1962C199.864 73.9859 199.7 73.8212 199.49 73.7754L194.494 72.6869C193.92 72.562 193.92 71.7441 194.494 71.6191L199.49 70.5306C199.7 70.4849 199.864 70.3202 199.909 70.1099L200.974 65.0756Z'
                            fill='#D8BBFF'
                        />

                        <path
                            d='M223.005 145.788L224.678 153.693L232.471 155.391L224.678 157.088L223.005 164.994L221.332 157.088L213.539 155.391L221.332 153.693L223.005 145.788Z'
                            fill='#D8BBFF'
                        />

                        <path
                            d='M169.641 83.8606L40.4102 133.312L68.0048 210.086L84.6709 217.462L105.435 221.834L126.473 221.014L138.767 218.828L149.696 215.55L167.728 206.261L183.028 194.239L184.209 192.712C190.877 184.093 196.789 174.914 201.88 165.278L169.641 83.8606Z'
                            fill='url(#paint0_linear_1501_9301)'
                        />

                        <path
                            d='M50.2467 111.045L36.5859 103.395L155.161 58.5874L148.877 74.1606L153.522 88.641L55.4377 126.071L50.2467 111.045Z'
                            fill='#E4D7F5'
                        />

                        <path
                            d='M67.457 209.402V209.402C79.4138 215.515 92.3586 219.463 105.692 221.063L106.025 221.103L115.531 221.103C122.652 221.103 129.753 220.345 136.713 218.843L139.07 218.334C146.512 216.727 153.697 214.103 160.423 210.536V210.536C165.671 207.753 170.605 204.414 175.14 200.577L176.612 199.332C180.547 196.002 184.199 192.35 187.529 188.415V188.415C192.191 182.904 196.196 176.87 199.463 170.433L202.425 164.594'
                            stroke='#E1D3F5'
                            strokeWidth='2'
                        />

                        <path d='M39.3633 131.762L68.0063 209.93' stroke='#E1D3F5' strokeWidth='2' />

                        <path d='M170.777 83.4031L202.2 165.508' stroke='#E1D3F5' strokeWidth='2' />

                        <path d='M34.4452 103.621L156.842 57.6292' stroke='#E1D3F5' strokeWidth='2' />

                        <path
                            d='M38.7278 133.17L169.055 82.9095L149.842 73.9868C149.291 73.7306 149.054 73.0733 149.317 72.5244L156.008 58.524'
                            stroke='#E1D3F5'
                            strokeWidth='2'
                        />

                        <path
                            d='M35.5437 103.244L49.3204 110.63C49.8441 110.911 50.0475 111.558 49.7783 112.088L39.3634 132.582'
                            stroke='#E1D3F5'
                            strokeWidth='2'
                        />

                        <path d='M34.9922 102.255L43.8692 124.444' stroke='#E1D3F5' strokeWidth='2' />

                        <path d='M49.9727 111.864L55.4369 127.164' stroke='#E1D3F5' strokeWidth='2' />

                        <path d='M149.422 73.6143L154.886 89.4607' stroke='#E1D3F5' strokeWidth='2' />

                        <path d='M156.105 58.78L163.949 80.3979' stroke='#E1D3F5' strokeWidth='2' />

                        <circle cx='90.6828' cy='125.798' r='5.7375' fill='#E4D7F5' />

                        <circle cx='82.4849' cy='96.2911' r='4.09821' fill='#F8F4FF' />

                        <circle cx='126.745' cy='112.137' r='5.7375' fill='#E4D7F5' />

                        <circle cx='107.622' cy='87.0018' r='4.09821' fill='#F8F4FF' />
                    </g>

                    <defs>
                        <linearGradient
                            id='paint0_linear_1501_9301'
                            x1='142.592'
                            y1='217.189'
                            x2='102.43'
                            y2='102.166'
                            gradientUnits='userSpaceOnUse'
                        >
                            <stop stopColor='#EEE2FF' />

                            <stop offset='1' stopColor='white' />
                        </linearGradient>

                        <clipPath id='clip0_1501_9301'>
                            <rect width='232' height='232' fill='white' />
                        </clipPath>
                    </defs>
                </svg>

                {/*<div className='product-empty-text'>{text}</div>*/}
                <div className='product-empty-text'>No products found</div>
            </div>
        </>
    );
};
